import { internalLink } from '../constants/common';

export const checkInternalLink = (url) => {
  for (const key in internalLink) {
    if (url.includes(internalLink[key].name)) {
      return internalLink[key].id;
    }
  }
  return null;
};
